import { GetterNames } from './keys'
import { PatientState } from './types'
import { FlatAPIData, flattenJsonApiResponse } from '@/store/utils/converter'
import { getPatientName, sortByPatientName } from '@/utils/patients'
import { PatientAttributes } from '@/jsonapi/Patients'

export type FlatPatient = FlatAPIData<PatientAttributes>
export type PatientNameById = {
  [key: string]: string
}

/* tslint:disable:no-shadowed-variable */
export const getters = {
  [GetterNames.patients]: (state: PatientState): FlatPatient[] => {
    return state.patients.map(flattenJsonApiResponse)
  },
  [GetterNames.activePatients]: (state: PatientState, getters): FlatPatient[] => {
    if (getters[GetterNames.patients] == null) {
      return null
    }
    return getters[GetterNames.patients].filter(patient => patient.status === 'active')
  },
  [GetterNames.patientById]: (state: PatientState, getters): ((string) => FlatPatient) => (patientId: string) => {
    if (getters[GetterNames.patients] == null) {
      return null
    }
    return getters[GetterNames.patients].find(p => p.id === patientId)
  },
  [GetterNames.patientNameMapById]: (state: PatientState, getters): PatientNameById => {
    return getters[GetterNames.patients].reduce((acc, patient) => {
      acc[patient.id] = getPatientName(patient)
      return acc
    }, {})
  },
  [GetterNames.patientOrderedByFullName]: (state: PatientState, getters) => {
    if (getters[GetterNames.patients] == null) {
      return null
    }
    return sortByPatientName(getters[GetterNames.patients])
  },
}
